import React, {FC} from 'react';
import styled from 'styled-components';
import {Ripple} from '../Ripple/Ripple';

interface HapticButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  dataTestId?: string;
}

export const HapticButton: FC<HapticButtonProps> = ({dataTestId, ...rest}) => {
  return <Ripple as={Button} data-testid={`${dataTestId}Button`} {...rest} />;
};

const Button = styled.button`
  transition: background 300ms ease-in-out, transform 75ms ease-in-out;

  :hover {
    background: rgba(0, 0, 0, 0.1);
  }

  :active {
    transform: scale(0.95);
  }
`;
